import axios from 'axios';
import type { Tour } from '../../Router/pages/TourEditPage/types';
import type { TourItemContent } from './types';

const getTourContent = async (
  tourId: string,
): Promise<{
  id: string;
  name: string;
  tourItems: TourItemContent[];
  cancelledTourItems: TourItemContent[];
  date: Date;
  coopId: string;
  buyers: Tour['buyers'];
}> => {
  const { data: tourContent } = await axios.get(
    `/tours/tour_content/${tourId}`,
  );

  tourContent.date = new Date(tourContent.date);

  // converting times to Date object
  const newTourItems = tourContent.tourItems.map(
    (tourItem: TourItemContent) => {
      const newTourItem = { ...tourItem };
      if (tourItem.time) {
        newTourItem.time = new Date(tourItem.time);
        newTourItem.timeEnd = new Date(tourItem.timeEnd!);
      }
      if (tourItem.originalTime) {
        newTourItem.originalTime = new Date(tourItem.originalTime);
        newTourItem.originalTimeEnd = new Date(tourItem.originalTimeEnd!);
      }
      return newTourItem;
    },
  );

  tourContent.tourItems = newTourItems;

  tourContent.buyers = tourContent.buyers.map(
    ({ id, name }: { id: string; name: string }) => ({
      key: id,
      value: id,
      label: name,
    }),
  );

  return tourContent;
};

export default getTourContent;
